export enum PicureSizes {
  small = '48x48',
  medium = '120x120',
  large = '240x240'
}
